import { HOME_PAGE, ONBOARDING_FEATURES } from '@dtx-company/true-common/src/constants/featureFlags'
import { PlanType } from '@dtx-company/true-common/src/types/planType'
import { useBillingPlanType } from '@app/common/src/hooks/useBillingPlanType/useBillingPlanType'
import { useFlowFeature } from '@dtx-company/inter-app/src/hooks/useFlowFeature/useFlowFeature'

export function useHomeFeatureFlag(): boolean {
  const [userHomepageFeatureFlag] = useFlowFeature(HOME_PAGE, { autoUpdate: true })
  const [onboardingQuestions] = useFlowFeature(ONBOARDING_FEATURES, { autoUpdate: true })
  const billingPlanType = useBillingPlanType()
  const isEnterprise = billingPlanType === PlanType.ENTERPRISE
  return !isEnterprise && onboardingQuestions && userHomepageFeatureFlag
}
